<template>
  <PageLayout contentBgcolor="#eee">
    <Appbar :title="`${balance}生金`">
      <div class="toolsright" slot="right">
        <router-link
          tag="div"
          :style="'color:' + $vuetify.theme.themes.light.headerColor"
          class="headerbuttom"
          to="BalanceIncomeIntroduce">
          <i class="iconfont question topicon"></i>
        </router-link>
        <router-link
          tag="div"
          :style="'color:' + $vuetify.theme.themes.light.headerColor"
          class="headerbuttom"
          to="BalanceIncomeRecord">
          <i class="iconfont touzhujilu topicon"></i>
        </router-link>
      </div>
    </Appbar>
    <div class="balanceIncomeContainer">
      <div :style="'background-color:' + $vuetify.theme.themes.light.headerBgColor" class="balanceIncomebg"></div>
      <div :style="'background-color:' + $vuetify.theme.themes.light.headerBgColor" class="balanceIncomerbg"></div>
      <div class="balanceIncomeContent">
        <div class="shouyi">昨日收益(元)</div>
        <div class="shouyiamount">{{ balanceIncome.incomeAmountYes }}</div>
        <div class="userbalance">用户{{ balance }}:{{ userInfo.balance }}元</div>
        <div class="shouyidetail">
          <div class="detailItem">
            <div class="text">累计收益(元)</div>
            <div class="numb">{{ balanceIncome.incomeAmountHisTotal }}</div>
          </div>
          <div class="detailItem">
            <div class="text">万份最高收益(元)</div>
            <div class="numb">{{ $tools.evaluate(balanceIncome.incomeAmountWanMonth / 30) }}</div>
          </div>
          <div class="detailItem">
            <div class="text">七日年化(元)</div>
            <div class="numb">{{ balanceIncome.incomeScaleYear }}</div>
          </div>
        </div>
        <div class="yujibox">
          <div class="yuji">
            <div class="numb">{{ balanceIncome.incomeAmountWanYear }}</div>
            <div class="text">预计万份年收益(元)</div>
          </div>
          <div class="yuji">
            <div class="numb">{{ balanceIncome.incomeAmountWanMonth }}</div>
            <div class="text">预计万份月收益(元)</div>
          </div>
        </div>
      </div>
      <div class="bigtips">
        <div class="textbox">
          <div class="textboxtitle">{{ balance }}能生金，娱乐添助力</div>
          <div class="textboxtext">每日凌晨五点准时收益</div>
          <div class="textboxtext">{{ balance }}生金，生金购彩0风险、高回报</div>
        </div>
        <img class="textboximg" src="@img/public/balanceIncome.png" alt="" />
      </div>
    </div>
  </PageLayout>
</template>
<script>
import Appbar from '@c/layout/Appbar'
import PageLayout from '@c/layout/PageLayout'
import { ApigetIncomeSummary } from '@api/service'
import app from '@/store/app'
export default {
  data: function() {
    return {
      pageLoading: 0,
      amountShow: true,
      //余额生金 昨日,今日预估,前日收益数据
      balanceIncome: {
        incomeAmountBefyes: 0,
        incomeAmountHisTotal: 0,
        incomeAmountMaxToday: 0,
        incomeAmountMinToday: 0,
        incomeAmountWanMonth: 0,
        incomeAmountWanYear: 0,
        incomeAmountYes: 0,
        incomeScaleBefyes: 0,
        incomeScaleMaxToday: 0,
        incomeScaleMinToday: 0,
        incomeScaleYear: 0,
        incomeScaleYes: 0
      }
    }
  },
  computed: {
    userInfo() {
      return this.$store.state.user.userInfo
    },
    balance() {
      return this.$store.getters['app/app_my_config'].balance.name
    }
  },
  components: {
    PageLayout,
    Appbar
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      this.getYesTodBefyesIncomeInfo()
    },
    getYesTodBefyesIncomeInfo() {
      return new Promise(async (reslove, reject) => {
        this.pageLoading = 1
        const res = await ApigetIncomeSummary()
        if (res.code == '12200') {
          this.balanceIncome = res.data
          this.pageLoading = 2
          reslove()
        } else {
          this.pageLoading = 3
          reject()
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.toolsright {
  display: flex;
  .headerbuttom {
    width: 30px;
    height: 44px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
.balanceIncomeContainer {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  padding-top: 25px;
  flex-direction: column;
  .balanceIncomebg {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 80px;
  }
  .balanceIncomerbg {
    position: absolute;
    left: 0;
    top: 80px;
    width: 100%;
    height: 50px;
    border-bottom-left-radius: 100px;
    border-bottom-right-radius: 100px;
  }
  .balanceIncomeContent {
    z-index: 10;
    width: 320px;
    padding: 23px 14px;
    border-radius: 8px;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #fff;
    flex-direction: column;
    .shouyi {
      color: #939393;
      font-size: 12px;
    }
    .shouyiamount {
      color: #fa6400;
      font-size: 24px;
      margin: 10px 0 5px;
    }
    .userbalance {
      font-size: 12px;
      color: #373737;
      margin-bottom: 24px;
    }
    .shouyidetail {
      display: flex;
      justify-content: space-between;
      width: 100%;
    }
    .detailItem {
      display: flex;
      flex-direction: column;
      justify-content: center;
      font-size: 12px;
      align-items: center;
      .text {
        color: #939393;
      }
      .numb {
        color: #373737;
        margin-top: 5px;
      }
    }
    .yujibox {
      display: flex;
      width: 100%;
      justify-content: space-around;
      margin-top: 25px;
    }
    .yuji {
      width: 115px;
      height: 44px;
      display: flex;
      background-color: #ebebeb;
      color: #414655;
      font-size: 14px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      border-radius: 5px;
      .text {
        font-size: 12px;
      }
    }
  }
  .bigtips {
    background-color: rgba(247, 178, 30, 0.2);
    height: 74px;
    width: 320px;
    margin-top: 25px;
    border-radius: 5px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 4px 10px;
    .textbox {
      display: flex;
      flex-direction: column;
      justify-content: space-around;
    }
    .textboxtitle {
      color: #dc5901;
      font-size: 14px;
    }
    .textboxtext {
      color: #939393;
      font-size: 12px;
    }
    .textboximg {
      width: 74px;
      height: 100%;
    }
  }
}
</style>
